import RoutesHeader from './RoutesHeader.jsx';
import Me from './Me/index.jsx';
import Games from './Games/index.jsx';
import Websites from './Websites/index.jsx';
import Code from './Code/index.jsx';
import Art from './Art/index.jsx';
import Writing from './Writing/index.jsx';
import Fieldsets from './Fieldsets.jsx';

import packageJson from '../package.json';

import './App.css';

function App() {
  return (
    <div className="App">
      <header>
        <pre style={{position: 'absolute', right: 0, top: 0, backgroundColor: 'white', border: 'solid 1px black'}}>{packageJson.version}</pre>
        <img className="App-titlecard" src="sopholophie.com.jpeg" alt="Sopholophie (colourful)" />
      </header>
      <RoutesHeader />
      <div className="body">
        <Me />
        <Games />
        <Websites />
        <Code />
        <Art />
        <Writing />
        <Fieldsets />
      </div>
    </div>
  );
}

export default App;
